export enum MOBILE_SDK_TYPE {
	APPIUM_JAVA = 'Appium Java SDK',
	APPIUM_PYTHON = 'Appium Python SDK',
	ESPRESSO = 'Espresso SDK',
	WEBDRIVERIO = 'WebdriverIO SDK',
	XCUI = 'XCUI SDK'
}

export enum MOBILE_SDK_DOCUMENTATION_LINK {
	APPIUM_JAVA = 'https://developer.evinced.com/sdks-for-mobile-apps/appium-sdk-java-doc',
	APPIUM_PYTHON = 'https://developer.evinced.com/sdks-for-mobile-apps/appium-sdk-python-doc',
	ESPRESSO = 'https://developer.evinced.com/sdks-for-mobile-apps/espresso-sdk',
	WEBDRIVERIO = 'https://developer.evinced.com/sdks-for-mobile-apps/wdio-mobile-sdk',
	XCUI = 'https://developer.evinced.com/sdks-for-mobile-apps/xcui-sdk'
}

export type MobileSdkInfo = {
	label: MOBILE_SDK_TYPE;
	version: string;
};
